import axios from "axios";
import { getAuthHeaders, getEnhancedAuthHeaders } from "./auth";
const backendUrl = process.env.REACT_APP_BACKEND_URL_FOR_FRONTEND;
const token = localStorage.getItem("token");

export const getAllUsers = async () => {
  try {
    const users = await axios.get(`${backendUrl}/users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return users;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllLocations = async () => {
  try {
    const locations = await axios.get(`${backendUrl}/locations`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return locations;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllCompanyUsers = async () => {
  try {
    const users = await axios.get(`${backendUrl}/users/companyusers`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return users.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// POST
export const addNewCompanyUser = async (user) => {
  try {
    const newCompanyUser = await axios.post(
      `${backendUrl}/users/companyusers`,
      user,
      {
        headers: getEnhancedAuthHeaders(),
      }
    );

    return {
      success: true,
      message: "User created successfully.",
      user: newCompanyUser.data,
    };
  } catch (error) {
    console.error("Error creating user:", error);

    // Handle specific error scenarios
    if (error.response?.status === 400) {
      return {
        success: false,
        message: "Invalid data provided.",
        details: error.response.data.details, // Include validation errors
      };
    }

    if (error.response?.status === 409) {
      return {
        success: false,
        message: "User already exists.",
      };
    }

    return {
      success: false,
      message: "Failed to create user.",
    };
  }
};

// UPDATE
export const updateCompanyUser = async (userId, updatedFields) => {
  console.log("updatedFields", updatedFields);
  try {
    const updatedUser = await axios.put(
      `${backendUrl}/users/${userId}`,
      updatedFields, // Pass the updated fields as the request body
      {
        headers: getAuthHeaders(),
      }
    );
    return updatedUser.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// DELETE
// SOFT DELETE USER
export const softDeleteCompanyUser = async (userId) => {
  console.log("userId in soft delete", userId);
  console.log("backendUrl", backendUrl);
  try {
    const deletedUser = await axios.patch(
      `${backendUrl}/users/softdelete/${userId}`,
      {}, // Empty payload for soft delete
      {
        headers: getEnhancedAuthHeaders(),
      }
    );

    return deletedUser.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
// HARD DELETE USER
export const deleteCompanyUser = async (userId) => {
  try {
    const deletedUser = await axios.delete(`${backendUrl}/users/${userId}`, {
      headers: getEnhancedAuthHeaders(),
    });
    return deletedUser.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
